/* eslint no-eval: 0 */
/* eslint no-unused-vars: 0 */

import { _eval } from './utils';

// Add all hook functions you want to expose here
const hooks = {
    _eval,
    filtreDisponibiliteTablesRondesEga2024,
    confirmationMessageDepandUponSubscription25ans,
    redirectDependsUponStatutField,
    subCheckboxesItemsDZA2023,
    mergeFieldsDZA2023,
    NvpPopulateInputItemsWithApiEndpointData,
    NvpPopulateSuccessMailWithApiEndpointData,
    // filtreDisponibiliteWebinaireOriane2024,
    limitedNumberOfSubmissions,
};

export const hook = async (fn, conf, formData = null) => {
    if (typeof fn === 'function') {
        return await fn(conf, formData);
    } else if (typeof fn === 'string' && hooks[fn]) {
        return await hooks[fn](conf, formData);
    } else {
        throw new Error(`Hook function '${fn}' not found.`);
    }
};

/*
* Ce hook permet de filtrer les items d'un radio en fonction de la disponibilité des tables rondes
* Il concerne le formulaire 2024-07_etats-generaux-de-l-alternance-experts-tr
* Si le nombre de places disponibles est atteint (70), l'item est retiré du radio
* @param {array} items - Les items du radio
* @return {items, config} - Les items du radio filtrés + un object config avec les paramètres à écraser
*/

async function filtreDisponibiliteTablesRondesEga2024(conf) {
    return new Promise((resolve, reject) => {

        let items = conf.inputs.find((input) => input.sid === 'FIELD_3').items;
        const listId = 293;
        const watchingForInterests = [
            'AEF_etats_generaux_apprentissage_2025_table_ronde_1',
            'AEF_etats_generaux_apprentissage_2025_table_ronde_2',
            'AEF_etats_generaux_apprentissage_2025_table_ronde_3'
        ];

        const promises = watchingForInterests.map((interest) => {
            return new Promise((resolve, reject) => {
                fetch("https://f.aefinfo.fr/form/api/api.php?action=count_user_with_interest&list_id=" + listId + "&interest=" + interest, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((data) => resolve({ item: interest, count: data }));
            });
        });

        Promise.all(promises).then((counts) => {
            counts = counts.map((value) => {
                return { item: value.item, count: value.count };
            });

            conf.inputs.find((input) => input.sid === 'FIELD_3').items = items.filter((item, i) => counts[i].count < 70);
            if (conf.inputs.find((input) => input.sid === 'FIELD_3').items.length === 0)
                resolve({
                    ...conf,
                    expiration: "1970-01-01T00:00:00",
                    expirationMessage: "Veuillez nous excuser, les tables rondes sont complètes. Les inscriptions sont closes.",
                });
            else resolve(conf)
        });

    })
}


/*
* Ce hook permet de modifier le message de confirmation 
* selon la reponse à la question "Participation à l'événement"
* pour le formulaire 2023-04_aef-25-ans-invitation
*/

async function confirmationMessageDepandUponSubscription25ans(conf, formData) {
    return new Promise((resolve, reject) => {
        if (_eval(formData, 'FIELD_4', 'value')
            && formData['FIELD_4'].value === 'Participation à l\'événement -> oui') {
            conf.sendSuccessMail.send = true;
            conf.successMessage = {
                title: "Confirmation d'inscription aux 25 ans du Groupe AEF Info !",
                content: "<p>Nous sommes ravis de vous compter parmi nous pour célébrer les 25 ans d’AEF info le jeudi 29 juin prochain.</p><p>Vous recevrez, quelques jours avant l’événement, une confirmation de votre inscription avec un QR code personnel, qu’il vous faudra présenter à l’accueil pour accéder à la soirée.<p>Au plaisir de vous retrouver dans les beaux murs du Musée Picasso,</p></p><p>L’équipe AEF info</p>",
            }
        }
        else {
            conf.sendSuccessMail.send = false;
            conf.successMessage = {
                title: "25 ans du Groupe AEF Info",
                content: "<p>Nous avons bien enregistré votre réponse.</p><p>L’équipe AEF info</p>",
            }
        }
        resolve(conf)
    })
}


/*
 *
 * Ce hook permet de rediriger l'utilisateur vers une page de confirmation
 * selon la réponse à la question "STATUT" sur les formulaires d'inscription à RPB ()
 */


async function redirectDependsUponStatutField(conf, formData) {
    return new Promise((resolve, reject) => {
        if (_eval(formData, 'STATUT', 'value')) {
            switch (formData['STATUT'].value) {
                case 'Enseignant(e) avec une classe / un groupe':
                case 'Enseignant(e) sans classe / groupe':
                    conf.redirectUrlAfterSubmit = 'https://www.reussirpostbac.fr/confirmation-inscription-enseignants/';
                    break;
                case 'Parent':
                    conf.redirectUrlAfterSubmit = 'https://www.reussirpostbac.fr/confirmation-inscription-parents/';
                    break;
                default:
                    conf.redirectUrlAfterSubmit = 'https://www.reussirpostbac.fr/confirmation-inscription-jeunes/';
            }
        }
        resolve(conf)
    })
}


/*
 *
 * Ce hook permet de modifier l'affichage des checkboxs
 * pour le formulaire 2023-06_dza-18eme-edition
 * Il affiche les sous-checkboxs en italique et les décale légèrement vers la droite
 * Il permet aussi de cocher automatiquement la checkbox parent si un sous-checkbox est coché   
 */

async function subCheckboxesItemsDZA2023(conf) {
    return new Promise((resolve, reject) => {
        window.extraEventsAtached = window.extraEventsAtached || false;
        let css = '';
        let checkboxes = conf.inputs.find((i) => i.sid === 'MESSAGE')
        let parentIndex = 0;
        checkboxes.items.forEach((c, i) => {

            if (c.startsWith('23 nov')) {
                parentIndex = i;
            }

            if (!c.startsWith('23 nov') && !window.extraEventsAtached) {
                css += `#checkbox-for-MESSAGE-key-${i} { margin-left: 10px; }`;
                css += `#checkbox-for-MESSAGE-key-${i} { margin-right: 5px; }`;
                css += `#checkbox-for-MESSAGE-key-${i} + label { width: calc(100% - 50px); font-size:.9rem; font-style:italic; }`;

                document.querySelector(`#checkbox-for-MESSAGE-key-${i}`).setAttribute('data-parent-checkbox', parentIndex);
                document.querySelector(`#checkbox-for-MESSAGE-key-${i}`).addEventListener('change', (e) => {
                    if (e.target.checked) {
                        var parentIndex = e.target.getAttribute('data-parent-checkbox');
                        document.querySelector(`#checkbox-for-MESSAGE-key-${parentIndex}`).checked = true;
                    }
                })

            }
        });
        window.extraEventsAtached = true;

        if (!document.head.querySelector('#subCheckboxesItemsDZA2023')) {
            var head = document.head || document.getElementsByTagName('head')[0],
                style = document.createElement('style');
            style.setAttribute('id', 'subCheckboxesItemsDZA2023');
            head.appendChild(style);
            style.type = 'text/css';
            style.appendChild(document.createTextNode(css));
        }

        resolve(conf)
    })
}

/*
 *
 * Ce hook permet de merger 2 champs en un seul
 * pour le formulaire 2023-06_dza-18eme-edition
 */

async function mergeFieldsDZA2023(conf, formData) {
    return new Promise((resolve, reject) => {

        const v1 = formData['MESSAGE__1']?.value || '';
        const v2 = formData['MESSAGE__2']?.value || '';
        formData['MESSAGE'] = {
            map: false,
            value: v1 + ' | ' + v2,
            validity: true,
        }

        resolve(conf)
    })
}

/*
 * Ce hook permet de recuperer les checboxes des formulaires
 *   2024-06_nvp-inscription-salon-2024-parcours-personnalise
 *   2025-11_nvp_inscription-parcours-personnalise
 * depuis l'API Wordpress du site nouvelleviepro.fr
 */
async function NvpPopulateInputItemsWithApiEndpointData(conf) {
    return new Promise((resolve, reject) => {
        let endpointOrigin;
        switch (window.location.hostname) {
            case 'f.aefinfo.fr':
            case 'www.nouvelleviepro.fr':
                // Si le domaine du site est celui de la prod
                endpointOrigin = 'https://www.nouvelleviepro.fr';
                break;
        
            default:
                // Dans tous les autres cas, utiliser la préprod
                endpointOrigin = 'https://preprod.nouvelleviepro.fr';
                break;
        }

        fetch( `${endpointOrigin}/wp-admin/admin-ajax.php?action=exhibition_interests_request`)
            .then((response) => response.json())
            .then((resp) => {
                conf.inputs.find((i) => i.items === '__souhaits__').items = resp.data.souhait;
                conf.inputs.find((i) => i.items === '__secteurs__').items = resp.data.secteur;
                resolve(conf)
            })
    })
}

/*
 * Ce hook permet de generer le parcours personnalisé pour les formulaires
 *   2024-06_nvp-inscription-salon-2024-parcours-personnalise
 *   2025-11_nvp_inscription-parcours-personnalise
 * depuis l'API Wordpress du site nouvelleviepro.fr
 * La requête ne peut pas se faire en local (NetworkError when attempting to fetch resource).
 */
async function  NvpPopulateSuccessMailWithApiEndpointData(conf, formData) {
    return new Promise((resolve, reject) => {
        let endpointOrigin;
        switch (window.location.hostname) {
            case 'f.aefinfo.fr':
            case 'www.nouvelleviepro.fr':
                // Si le domaine du site est celui de la prod
                endpointOrigin = 'https://www.nouvelleviepro.fr';
                break;
        
            default:
                // Dans tous les autres cas, utiliser la préprod
                endpointOrigin = 'https://preprod.nouvelleviepro.fr';
                break;
        }

        fetch( `${endpointOrigin}/wp-admin/admin-ajax.php?action=exhibition_interests_get_route&data=${encodeURIComponent(JSON.stringify(formData))}`)
            .then((response) => response.json())
            .then((resp) => {
                conf.sendSuccessMail._MAIL_TEMPLATE_PARAMS = {
                    parcours_visiteur: resp.data
                }
                resolve(conf)
            })
    })
}

/*
 *
 * Ce hook permet de limiter le nombre d'inscription pour
 * le formulaire 2024-12_oriane-webinaire-numerique-ia 
 */

async function filtreDisponibiliteWebinaireOriane2024(conf) {
    return new Promise((resolve, reject) => {

        const listId = 9;

        fetch("https://f.aefinfo.fr/form/api/api-cdt.php?action=count_user_with_interest&list_id=" + listId + "&interest=WEBINAIRE_IA_ORIANE_2024", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((count) => {

                console.log(count)
                if (count >= 250)
                    resolve({
                        ...conf,
                        expiration: "1970-01-01T00:00:00",
                        expirationMessage: "Veuillez nous excuser, nous avons atteint le nombre maximum d'inscriptions pour ce webinaire.",
                    });
                else resolve(conf)
            });

    })
}

/*
 * Ce hook permet de limiter le nombre d'inscriptions pour un formulaire donné.
 * Il requête l'API PHP qui compte le nombre total de contacts dont l'adresse e-mail est différente.
 * 
 * @param   conf        Ce param. est automatiquement récupéré par la fonction appelée via le JSON (clé "hook").
 * @var     listId      L'ID de la liste Brevo tel que défini dans la clé "inputs > [0] > value" ("sid": "_LIST_ID").
 * @var     limitNum    Un nombre entier qui défini la limite d'entrées à ne pas dépasser (clé "submissionsLimit" dans le JSON).
 * @var     limitMsg    Le message à afficher à la place du formulaire lorsque la limite est atteinte (clé "limitMessage" dans le JSON).
 * 
 * @eg      2026_fncibc_inscription.json
 */
async function limitedNumberOfSubmissions(conf) {
    return new Promise((resolve, reject) => {

        const listId = conf.inputs[0].value;
        const limitNum = conf.submissionsLimit;
        const limitMsg = conf.limitMessage;

        fetch("https://f.aefinfo.fr/form/api/api-cdt.php?action=count_contacts_in_list&list_id=" + listId, {
            method: "GET",
        })
        .then((response) => response.json())
        .then((count) => {
            if (count >= limitNum) {
                resolve({
                    ...conf,
                    expiration: "1970-01-01T00:00:00",
                    expirationMessage: limitMsg,
                });
            }
            else {
                resolve(conf);
            }
        });

    })
}
